import React from 'react';
import bgPattern from "../assets/Onboarding-Form.jpg";
import { useLocation, useNavigate } from 'react-router-dom';

const Row: React.FC<{ label: string; value?: React.ReactNode }> = ({ label, value }) => (
  <div className="flex flex-col gap-1">
    <div className="text-sm text-gray-500">{label}</div>
    <div className="text-base text-gray-800 whitespace-pre-wrap break-words bg-[#F4F3FF] border border-[#E2D5FF] rounded-xl p-3">
      {value || '-'}
    </div>
  </div>
);

const StorefrontReviewPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation() as any;
  const formData = location?.state?.formData || {};

  return (
    <div className="min-h-screen bg-gradient-to-tr from-[#E9E3FF] to-[#F8F6FF]" style={{
      backgroundImage: `url(${bgPattern})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }}>
      <div className="container mx-auto px-4" style={{paddingTop: 144, paddingBottom: 90}}>
        <div className="text-center mb-12">
          <h1 className="font-roboto font-semibold text-3xl text-[#4A3B8E]" style={{ fontSize: 40, marginBottom: 12 }}>Review Your Storefront Inputs</h1>
          <p className="mb-8" style={{ color: '#4A3B8E', fontSize: 16 }}>Make sure everything looks right. You can go back and edit.</p>
        </div>

        <div className="bg-white shadow-md mx-auto p-8 space-y-8" style={{ width: 1160, borderRadius: '20px' }}>
          <div>
            <h3 className="font-roboto font-semibold text-lg text-[#4A3B8E] mb-4">Personal Details</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Row label="First Name" value={formData.firstName} />
              <Row label="Last Name" value={formData.lastName} />
            </div>
            <div className="mt-4">
              <Row label="Email" value={formData.email} />
            </div>
          </div>

          <div>
            <h3 className="font-roboto font-semibold text-lg text-[#4A3B8E] mb-4">Company Details</h3>
            <div className="space-y-4">
              <Row label="Brand Name" value={formData.brandName} />
              <Row label="Website" value={formData.website} />
              <Row label="Product Count & Categories" value={(
                formData.productCountAndCategoriesFileName ? (
                  <span>
                    File: {formData.productCountAndCategoriesFileName}
                    {formData.productCountAndCategoriesFileUrl && (
                      <a className="ml-3 underline text-[#564DB8]" href={formData.productCountAndCategoriesFileUrl} download={formData.productCountAndCategoriesFileName}>Download</a>
                    )}
                  </span>
                ) : (formData.productCountAndCategories || '')
              )} />
              <Row label="Product ASINs or Links" value={(
                formData.productAsinsOrLinksFileName ? (
                  <span>
                    File: {formData.productAsinsOrLinksFileName}
                    {formData.productAsinsOrLinksFileUrl && (
                      <a className="ml-3 underline text-[#564DB8]" href={formData.productAsinsOrLinksFileUrl} download={formData.productAsinsOrLinksFileName}>Download</a>
                    )}
                  </span>
                ) : (formData.productAsinsOrLinks || '')
              )} />
              <Row label="Best Sellers or Hero Items" value={formData.bestSellersOrHeroes} />
              <Row label="Brand Mentions / Media" value={formData.hasBrandMentions ? 'Yes' : 'No'} />
              <Row label="Key Features / Benefits" value={formData.keyFeaturesBenefits} />
              <Row label="Target Audience" value={formData.targetAudience} />
            </div>
          </div>

          <div>
            <h3 className="font-roboto font-semibold text-lg text-[#4A3B8E] mb-4">Competitors</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <Row label="Competitor 1" value={formData.competitor1} />
              <Row label="Competitor 2" value={formData.competitor2} />
              <Row label="Competitor 3" value={formData.competitor3} />
            </div>
            <div className="space-y-4 mt-4">
              <Row label="Closest Competitor" value={formData.closestCompetitor} />
              <Row label="Likes/Dislikes & Differentiation" value={formData.competitorLikeDislike} />
              <Row label="How do you compare?" value={formData.brandComparison} />
            </div>
          </div>

          <div>
            <h3 className="font-roboto font-semibold text-lg text-[#4A3B8E] mb-4">Tone & Style</h3>
            <div className="space-y-4">
              <Row label="Brand Tonality" value={formData.brandTonality} />
              <Row label="Inspirations / References" value={formData.inspirationsReferences} />
              <Row label="Desired Design Style" value={formData.desiredDesignStyle} />
            </div>
          </div>

          <div>
            <h3 className="font-roboto font-semibold text-lg text-[#4A3B8E] mb-4">Favorite Brands</h3>
            <div className="space-y-6">
              <Row label="Brand 1 - Link" value={formData.favBrand1Link} />
              <Row label="Brand 1 - Describe" value={formData.favBrand1Describe} />
              <Row label="Brand 2 - Link" value={formData.favBrand2Link} />
              <Row label="Brand 2 - Describe" value={formData.favBrand2Describe} />
              <Row label="Brand 3 - Link" value={formData.favBrand3Link} />
              <Row label="Brand 3 - Describe" value={formData.favBrand3Describe} />
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-4 pt-4">
            <button onClick={() => navigate(-1)} className="w-full md:w-1/3 py-3 font-semibold rounded-lg text-[#4A3B8E] border border-[#4A3B8E]">Back & Edit</button>
            <button onClick={() => navigate('/storefront-submission-successful', { state: { formData } })} className="w-full md:w-2/3 py-3 text-white font-semibold rounded-lg" style={{
              background: 'linear-gradient(90deg, #362E7F 0%, #5A4ABE 45.67%, #7F60BF 100%)'
            }}>Submit</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StorefrontReviewPage;


